export default {
  /** 查询停发电列表 */
  queryList: '/service/power/queryList',
  /**  查询停发电统计数据 */
  statistics: '/service/power/statistics',
  /**  导出 */
  export: '/service/power/export'
}
